<div [class.dark-theme]="true" class="fix-action-dialog">
	<div fxLayout="row" fxLayoutAlign="start">
		<div class="card-title">
			<h2 data-idtest="welcome-dialog-t-7Nt" mat-dialog-title style="font-size: 24px;color:#ffffff;font-weight: 600;"><span data-idtest="guests-dialog-t-8Cb" translate>会員情報</span></h2>
			<h2 mat-dialog-title style="font-size: 14px;color:#ffffff;font-weight: 600;"><span data-idtest="guests-dialog-t-3Cr" translate>メールアドレス</span>：{{content.username}}</h2>
			<h3 *ngIf="authIs('manager')" style="color:#ffffff;font-weight: 600;">{{content.stripe_id}}</h3>
		</div>
	</div>
	<mat-dialog-content>
		<div fxLayout="row" fxLayout.lt-sm="column" style="padding:8px">
			<form fxFlex="60" fxFlex.lt-sm="100" #form="ngForm" fxLayout="column" fxLayoutAlign="space-between" style="margin:8px;" novalidate>
				<div fxLayout="row wrap" fxLayoutAlign="space-around">
					<mat-checkbox *ngIf="accountTypeEq('studio') && authIs('manager')" [(ngModel)]="content.accounting" name="accounting"><span data-idtest="guests-dialog-t-1Yg" style="color:#ffffff;" translate>請求書払いスタジオの場合はチェック</span></mat-checkbox>
					<span *ngIf="authIs('manager')">
						<mat-slide-toggle [(ngModel)]="content.enabled" [disabled]="false" labelPosition="before" class="example-margin" name="enable"><span data-idtest="guests-dialog-t-5Hr" style="color:#ffffff;" translate>休止</span></mat-slide-toggle>
						<span data-idtest="guests-dialog-t-0Rl" style="margin-left: 6px;color:#ffffff;" translate>有効</span>
					</span>
				</div>

				<mat-form-field style="margin: 12px;">
					<mat-label><span data-idtest="guests-dialog-t-6Jq" translate>会員名</span></mat-label>
					<input #nickname="ngModel" [(ngModel)]="content.nickname" autocomplete="off" matInput maxlength="255" minlength="2" name="nickname" placeholder="" required type="text">
					<mat-hint><span data-idtest="guests-dialog-t-7Mf" translate>2文字以上255文字まで</span></mat-hint>
					<mat-error *ngIf="nickname.errors?.['required'];"><span translate>入力してください</span></mat-error>
					<mat-error *ngIf="nickname.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
					<mat-error *ngIf="nickname.errors?.['minlength']"><span translate>短すぎます</span></mat-error>
				</mat-form-field>

				<div *ngIf="authIs('manager')" fxLayout="row wrap" fxLayoutAlign="space-around">
					<mat-form-field>
						<mat-label><span data-idtest="guests-dialog-t-8Ct" translate>アカウント権限</span></mat-label>
						<mat-select #auth_select="ngModel" [(ngModel)]="content.auth" name="auth_select" required>
							<mat-option *ngFor="let auth of auths" [value]="auth.value">
								{{auth.name}}
							</mat-option>
						</mat-select>
						<mat-error *ngIf="auth_select.errors?.['required'];"><span translate>入力してください</span></mat-error>
					</mat-form-field>
					<mat-form-field>
						<mat-label><span data-idtest="guests-dialog-t-0Tx" translate>アカウント種別</span></mat-label>
						<mat-select #type_select="ngModel" [(ngModel)]="content.type" name="type_select">
							<mat-option *ngFor="let type of types" [value]="type.value">
								{{type.name}}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div fxLayout="row wrap" fxLayoutAlign="space-around">
					<mat-form-field>
						<mat-label><span data-idtest="guests-dialog-t-6Uv" translate>身長</span></mat-label>
						<div fxLayout="row">
							<input [(ngModel)]="content.height" matInput max="999" min="0" name="height" placeholder="" step="1" style="text-align: right;" type="number">
							<div data-idtest="guests-dialog-t-3Ko" translate>cm</div>
						</div>
					</mat-form-field>
					<mat-form-field>
						<mat-label><span data-idtest="guests-dialog-t-3Bs" translate>ゴルフ暦</span></mat-label>
						<div fxLayout="row">
							<input [(ngModel)]="content.experience" matInput max="999" min="0" name="experience" placeholder="" step="1" style="text-align: right;" type="number">
							<div data-idtest="guests-dialog-t-1Id" translate>年</div>
						</div>
					</mat-form-field>
					<mat-form-field>
						<mat-label><span data-idtest="guests-dialog-t-6Ai" translate>平均スコア</span></mat-label>
						<input [(ngModel)]="content.score" matInput max="999" min="0" name="score" placeholder="" step="1" style="text-align: right;" type="number">
					</mat-form-field>
					<mat-form-field>
						<mat-label><span data-idtest="guests-dialog-t-3Eh" translate>ドライバーの距離</span></mat-label>
						<div fxLayout="row">
							<input [(ngModel)]="content.driver" matInput max="999" min="0" name="driver" placeholder="" step="1" style="text-align: right;" type="number">
							<div data-idtest="guests-dialog-t-4Kn" translate>Yard</div>
						</div>
					</mat-form-field>
					<mat-form-field>
						<mat-label><span data-idtest="guests-dialog-t-2Jv" translate>7番アイアンの距離</span></mat-label>
						<div fxLayout="row">
							<input [(ngModel)]="content.seveniron" matInput max="999" min="0" name="seveniron" placeholder="" step="1" style="text-align: right;" type="number">
							<div data-idtest="guests-dialog-t-8Lb" translate>Yard</div>
						</div>
					</mat-form-field>
					<mat-form-field>
						<mat-label><span data-idtest="guests-dialog-t-0Rp" translate>年間ラウンド回数</span></mat-label>
						<div fxLayout="row">
							<input [(ngModel)]="content.rounds" fxFlex="80" matInput max="999" min="0" name="rounds" placeholder="" step="1" style="text-align: right;" type="number">
							<div data-idtest="guests-dialog-t-9Xj" fxFlex translate>回</div>
						</div>
					</mat-form-field>
					<mat-form-field>
						<mat-label><span data-idtest="guests-dialog-t-4Sp" translate>月間練習回数</span></mat-label>
						<div fxLayout="row">
							<input [(ngModel)]="content.practice" fxFlex="80" matInput max="999" min="0" name="practice" placeholder="" step="1" style="text-align: right;" type="number">
							<div data-idtest="guests-dialog-t-8Nt" fxFlex translate>回</div>
						</div>
					</mat-form-field>
					<mat-form-field>
						<mat-label><span data-idtest="guests-dialog-t-5Rb" translate>オフィシャルハンディ</span></mat-label>
						<input [(ngModel)]="content.handicap" matInput max="99" min="0" name="handicap" placeholder="" step="1" style="text-align: right;" type="number">
					</mat-form-field>
				</div>
				<mat-form-field>
					<mat-label><span data-idtest="guests-dialog-t-5Tt" translate>詳細</span></mat-label>
					<textarea #description="ngModel" [(ngModel)]="content.description" matInput maxlength="255" name="description" placeholder="" type="text"></textarea>
					<mat-hint><span data-idtest="guests-dialog-t-8Rs" translate>3文字以上255文字まで</span></mat-hint>
					<mat-error *ngIf="description.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
				</mat-form-field>
			</form>
			<div fxFlex="40" fxFlex.lt-sm="100" style="margin:8px;">
				<div style="font-size: 14px; font-weight: 200; margin: 8px; color: #ffffff;"><span data-idtest="guests-dialog-t-4Ai" translate>このアカウントの所属</span></div>
				<belongs-panel #belongs_panel [auth]="auth" [account]="account"></belongs-panel>
			</div>
		</div>
	</mat-dialog-content>

	<div class="spacer"></div>

	<mat-dialog-actions fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-around">
		<button data-idtest="guests-dialog-b-9Ke" (click)="cancel()" color="warn" mat-dialog-close="" mat-stroked-button id="mat-cancel-button"><span data-idtest="guests-dialog-t-6Ql" translate>キャンセル</span></button>
		<button (click)="onAccept()" [disabled]="form.invalid" color="primary" mat-raised-button id="mat-ok-button"><span data-idtest="guests-dialog-t-5Bv" translate>OK</span></button>
	</mat-dialog-actions>
</div>
